import { useState, useCallback } from 'react';

/**
 * Custom hook to manage credential modal states
 * @returns {Object} Modal states and handlers
 */
const useCredentialModals = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showResourcesModal, setShowResourcesModal] = useState(false);
    const [selectedCredential, setSelectedCredential] = useState(null);

    const handleShowAdd = useCallback(() => {
        setShowAddModal(true);
        setSelectedCredential(null);
    }, []);

    const handleShowEdit = useCallback((credential) => {
        setSelectedCredential(credential);
        setShowEditModal(true);
    }, []);

    const handleShowDetails = useCallback((credential) => {
        setSelectedCredential(credential);
        setShowDetailsModal(true);
    }, []);

    const handleShowResources = useCallback((credential) => {
        setSelectedCredential(credential);
        setShowResourcesModal(true);
    }, []);

    const handleCloseModals = useCallback(() => {
        setShowAddModal(false);
        setShowEditModal(false);
        setShowDetailsModal(false);
        setShowResourcesModal(false);
        setSelectedCredential(null);
    }, []);

    return {
        showAddModal,
        showEditModal,
        showDetailsModal,
        showResourcesModal,
        selectedCredential,
        handleShowAdd,
        handleShowEdit,
        handleShowDetails,
        handleShowResources,
        handleCloseModals,
    };
};

export default useCredentialModals;
